import PropTypes from "prop-types";

import Toggle from "./Toggle";

export default function FieldToggle({ label, desc, value, onChange, disabled }) {
  return (
    <div className="rec-toggle-row">
      <div className="flex-1">
        <div className="text-[13.5px] font-semibold text-ink">{label}</div>
        {desc && <div className="text-[11.5px] text-ink-3 mt-[2px]">{desc}</div>}
      </div>
      <Toggle on={value} onClick={() => onChange?.(!value)} disabled={disabled} />
    </div>
  );
}

FieldToggle.propTypes = {
  label: PropTypes.node,
  desc: PropTypes.node,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

FieldToggle.defaultProps = {
  label: null,
  desc: null,
  value: false,
  onChange: undefined,
  disabled: false,
};
